import { render, staticRenderFns } from "./PolicyView.vue?vue&type=template&id=e23904c6&"
import script from "./PolicyView.vue?vue&type=script&lang=js&"
export * from "./PolicyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports